//import external libraries
import React from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useState } from "react";
import PropTypes from "prop-types";

import { sizeOfUnitMapping } from "../../../utils/unitConstants";

//import MUI components
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BlurLinearIcon from "@mui/icons-material/BlurLinear";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import EngineeringIcon from "@mui/icons-material/Engineering";
import HeatPumpIcon from "@mui/icons-material/HeatPump";
import useMediaQuery from "@mui/material/useMediaQuery";

import { getInstallationType, getFineFilterType, getUnitTypeLabel } from "../../../utils/helper";
import { useSelector } from "react-redux";

function ProjectItemCard(props) {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const { isClivet } = useSelector((state) => state.brand);
  const installationType = getInstallationType(props.installation);


  const handleChange = (event, newValue) => {
    setValue(newValue);

    props.fieldGroup(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        maxWidth: { xs: "100vw", sm: "60vw" },

        mx: "20%",
        my: "2%",
        bgcolor: "#C4C4C4",
        borderLeft: `5px solid ${theme.palette.secondary.main}`,

        "&.MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer": {
          justifyContent: "space-between",
          width: "100%",
        },
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={true}
        allowScrollButtonsMobile
        aria-label="scrollable auto tabs example"
        sx={{
          "& .MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer": {
            justifyContent: "space-between",
            width: "100%",
          },
        }}
      >
        <Tab
          icon={<AssignmentIcon />}
          label={isSmallScreen ? "" : t("mainform.info")}
        />
        <Tab
          icon={<EngineeringIcon />}
          label={isSmallScreen ? "" : t("mainform.requirements")}
          sx={{}}
        />
        <Tab
          icon={<LibraryAddCheckIcon />}
          label={isSmallScreen ? "" : t("mainform.typeOfUnit")}
          sx={{}}
        />
        <Tab
          icon={<GpsFixedIcon />}
          label={isSmallScreen ? "" : t("mainform.operatingpoint")}
          sx={{}}
        />
        <Tab
          icon={<BlurLinearIcon />}
          label={isSmallScreen ? "" : t("mainform.filtering")}
          sx={{}}
        />
        <Tab
          icon={<HeatPumpIcon />}
          label={isSmallScreen ? "" : t("mainform.fan")}
          sx={{}}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
        >
          {props.area !== 0 ? (
            <>
              <Grid item xs={6} md={3}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("calculation.area")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.area} m²
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("calculation.height")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.height} m
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("calculation.buildingType")}
                </Typography>
                <Typography variant="body1" component="div">
                  {t(`buildingTypes.${props.buildingType}`)}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("calculation.changeRate")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.changeRate}
                </Typography>
              </Grid>
            </>
          ) : (
            <></>
          )}

          <Divider />

          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.flowSupply")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.flowSupply} m³/h
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.flowReturn")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.flowReturn} m³/h
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.dropSupply")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.dropSupply} Pa
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.dropReturn")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.dropReturn} Pa
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.ecodesign")}
            </Typography>

            <Typography variant="body1" component="div">
              {t(`requirementsList.${props.ecoDesign}`)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.casingQuality")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.casingQuality}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.maintenance")}
            </Typography>
            <Typography variant="body1" component="div">
              {t(`requirementsList.${props.maintenance}`)}
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.installation")}
            </Typography>
            <Typography variant="body1" component="div">
              {t(`unitTypeList.${installationType}`)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.unitType")}
            </Typography>
            <Typography variant="body1" component="div">
              {getUnitTypeLabel(props.unitType, isClivet)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.heatRecovery")}
            </Typography>
            <Typography variant="body1" component="div">
              {t(`unitTypeList.${props.heatRecovery}`)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.heatRecoveryPlateType")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.unitSize <= 5
                ? t(`unitType.Rotary`)
                : props.unitSize > 10
                ? t(`unitType.Enthalpy`)
                : t(`unitType.Condensing`)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.sizeOfUnit")}
            </Typography>
            <Typography variant="body1" component="div">
              {sizeOfUnitMapping[props.unitSize] || props.unitSize}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.unitDivision")}
            </Typography>
            <Typography variant="body1" component="div">
              {t(`unitTypeList.${props.unitDivision}`)}
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Divider textAlign="left"> {t("createproject.summer")}</Divider>
        <Grid
          container
          direction="row"
          justifyContent="start"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.dryBulbTemperatureCelsius")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerOutdoorTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.wetBulbTemperatureCelsius")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerWetBulbTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.dewPointTemperatureCelsius")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerDewPointTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.relativeHumiditySummer")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerOutdoorHumidity} %
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.summerIndoorTemperature")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerIndoorTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.summerIndoorHumidity")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.summerIndoorHumidity}%
            </Typography>
          </Grid>
          {(props.coils === "cooler" || props.coils === "both") && (
            <>
              <Grid item xs={12} md={12}>
                <Divider textAlign="left">{t("unitType.cooler")}</Divider>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {props.coolerAirInputParam}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.coolerAirInputParamValue}{" "}
                  {props.coolerAirInputParam != "Supply Temperature"
                    ? "kW"
                    : "°C"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.heaterType")}
                </Typography>
                <Typography variant="body1" component="div">
                  {t("operatingpoint.heatingType." + props.coolerType)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.concentration")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.coolerConcentration} %
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.temperatureIn")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.coolerTemperatureIn} °C
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {props.coolerWaterInputParam}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.coolerWaterInputParamValue}
                  {props.coolerWaterInputParam != "Temperature out"
                    ? "m³/h"
                    : "°C"}
                  {/*props.coolerTemperatureOut*/}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
        <Divider textAlign="left"> {t("createproject.winter")}</Divider>
        <Grid
          container
          direction="row"
          justifyContent="start"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.heatingDB")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.winterOutdoorTemperature} °C
            </Typography>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("createproject.humidityRatio")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.humidityRatio}
            </Typography>
    </Grid>*/}

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.relativeHumidityWinter")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.winterOutdoorHumidity} %
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            {/*  <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("createproject.elevation")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.elevation}
  </Typography>*/}
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.winterIndoorTemperature")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.winterIndoorTemperature} °C
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.winterIndoorHumidity")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.winterIndoorHumidity} %
            </Typography>
          </Grid>
          {(props.coils === "heater" || props.coils === "both") && (
            <>
              <Grid item xs={12} md={12}>
                <Divider textAlign="left">{t("unitType.heater")}</Divider>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {props.heaterAirInputParam}
                  {/*t("operatingpoint.winterSupplyTemperature")*/}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.heaterAirInputParamValue}{" "}
                  {props.heaterAirInputParam != "Supply Temperature"
                    ? "kW"
                    : "°C"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.heaterType")}
                </Typography>
                <Typography variant="body1" component="div">
                  {t("operatingpoint.heatingType." + props.heaterType)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.concentration")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.heaterConcentration} %
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {t("operatingpoint.temperatureIn")}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.heaterTemperatureIn} °C
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  {props.heaterWaterInputParam}
                </Typography>
                <Typography variant="body1" component="div">
                  {props.heaterWaterInputParamValue}
                  {props.heaterWaterInputParam != "Temperature out"
                    ? "m³/h"
                    : "°C"}
                </Typography>
              </Grid>
            </>
          )}
          <Grid item xs={12} md={4}>
            <Paper elevation={0}></Paper>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          {/* <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.supplyAirFilter")}
    </Typography>*
            <Typography variant="body1" component="div">
              {props.supplyAirFilter}
            </Typography>
    </Grid>*/}
          {/* <Grid item xs={12} md={12}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.doubleStageFiltering")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.doubleStageFiltering}
            </Typography>
          </Grid> */}
          {/*<Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.extractAirFilter")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.extractAirFilter}
            </Typography>
  </Grid>*/}
          {/* <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.filteringAdvancedSettings")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.filteringAdvancedSettings}
            </Typography>
          </Grid> */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("calculation.fineFilterType")}
            </Typography>
            <Typography variant="body1" component="div">
              {t(`filteringList.${getFineFilterType(props.unitType)}`)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {props.fineFilterClassSupply !== props.fineFilterClassReturn
                ? t("filtering.supplyFilter")
                : t("filteringTextFields.label2")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.fineFilterClassSupply}
            </Typography>
          </Grid>
          {props.fineFilterClassSupply !== props.fineFilterClassReturn && (
            <Grid item xs={12} md={4}>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                gutterBottom
              >
                {t("filtering.returnFilter")}
              </Typography>
              <Typography variant="body1" component="div">
                {props.fineFilterClassReturn}
              </Typography>
            </Grid>
          )}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {t("calculation.fanAdvancedSettings")}
        </Typography>
        <Typography variant="body1" component="div">
          {t(`fanType.${props.fanAdvancedSettings}`)}{" "}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {t("calculation.fanType")}
        </Typography>
        <Typography variant="body1" component="div">
          {t(`fanType.${props.fanType}`)}
        </Typography>
      </TabPanel>
    </Box>
  );
}

export default ProjectItemCard;
